import { svg } from 'lit';

const symbol = svg`<svg width="17" height="12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M.45 6.278a.8.8 0 010-.557 8.6 8.6 0 0115.9 0 .8.8 0 010 .557 8.6 8.6 0 01-15.9 0z" stroke="#000" stroke-width=".8" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.4 8.4a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8z" stroke="#000" stroke-width=".8" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

export { symbol as default };
